const MtrArrowLeftOutline={
    "name": "mtr-arrow-left",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M16.121 18.2807C16.2165 18.373 16.2927 18.4833 16.3451 18.6053C16.3975 18.7273 16.4251 18.8585 16.4263 18.9913C16.4274 19.1241 16.4021 19.2558 16.3518 19.3787C16.3015 19.5016 16.2273 19.6132 16.1334 19.7071C16.0395 19.801 15.9278 19.8753 15.805 19.9255C15.6821 19.9758 15.5504 20.0011 15.4176 20C15.2848 19.9988 15.1536 19.9712 15.0316 19.9188C14.9096 19.8664 14.7992 19.7902 14.707 19.6947L7 11.9877L14.707 4.28071C14.8956 4.09855 15.1482 3.99776 15.4104 4.00004C15.6726 4.00232 15.9234 4.10749 16.1088 4.29289C16.2942 4.4783 16.3994 4.72911 16.4017 4.99131C16.404 5.25351 16.3032 5.50611 16.121 5.69471L9.828 11.9877L16.121 18.2807Z",
                    "fill": "currentColor"
                }
            }
        ]
    }
};
export default MtrArrowLeftOutline;